export default __webpack_public_path__ + "static/media/chinese.84edfb66.svg";